// Sidebar desktop — navigasi berkelompok (rfc-006 §4.1). Hanya tampil di
// lg+. Grup & item difilter permission via lib/nav. Item tanpa izin
// disembunyikan; grup kosong tidak dirender.

import { NavLink } from "react-router-dom";
import { cn } from "@ds/lib/utils";
import { useAuth } from "../../lib/auth";
import { visibleGroups } from "../../lib/nav";

export function Sidebar() {
  const { can, account, isOwner } = useAuth();
  const groups = visibleGroups(can);
  const roleLabel = account?.role === "developer" ? "Developer" : isOwner ? "Pemilik" : "Kasir";

  return (
    <aside className="hidden h-screen w-60 shrink-0 flex-col border-r border-border bg-surface lg:flex">
      <div className="flex h-16 items-center gap-2 border-b border-border px-4">
        <div className="min-w-0">
          <div className="truncate font-semibold leading-tight">Reza POS</div>
          <div className="text-xs text-muted">{roleLabel}</div>
        </div>
      </div>

      <nav className="flex-1 space-y-5 overflow-y-auto p-3">
        {groups.map((group) => (
          <div key={group.label}>
            <div className="px-2 pb-1 text-xs font-medium uppercase tracking-wide text-muted">
              {group.label}
            </div>
            <div className="space-y-0.5">
              {group.items.map((item) => (
                <NavLink
                  key={item.key}
                  to={item.path}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary text-primary-ink"
                        : "text-ink hover:bg-faint",
                    )
                  }
                >
                  <item.icon className="size-4 shrink-0" aria-hidden />
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="truncate border-t border-border p-3 text-xs text-muted">
        Masuk sebagai <span className="font-medium text-ink">{account?.name}</span>
      </div>
    </aside>
  );
}
